import { GridRootUrl } from 'components/grid/v2/context/hierarchy-context';
import { useMemo } from 'react';
import { ResearchSheet } from 'types';

export interface MenuItem {
  label: string;
  href: string;
  primary: boolean;
  showToUnlogged: boolean;
  showToLogged: boolean;
}

export function useMenuItems(userSheet?: ResearchSheet): MenuItem[] {
  return useMemo(
    () => [
      {
        label: 'Hledat',
        href: '/hledat',
        primary: false,
        showToUnlogged: true,
        showToLogged: true,
      },
      {
        label: 'Fondy',
        href: GridRootUrl.COLLECTIONS,
        primary: false,
        showToUnlogged: true,
        showToLogged: true,
      },
      {
        label: 'Pomůcky',
        href: GridRootUrl.AIDS,
        primary: false,
        showToUnlogged: true,
        showToLogged: true,
      },
      {
        label: 'Rejstříky',
        href: '/rejstriky',
        primary: false,
        showToUnlogged: true,
        showToLogged: true,
      },
      {
        label: 'Nápověda',
        href: '/napoveda',
        primary: false,
        showToUnlogged: true,
        showToLogged: true,
      },
      {
        label: 'Registrace',
        href: '/registrace',
        primary: false,
        showToUnlogged: true,
        showToLogged: false,
      },
      {
        label: 'Můj archiv',
        href: `${
          userSheet?.id
            ? '/portfolio/zadat-badatelsky-dotaz'
            : '/portfolio/badatelske-listy'
        }`,
        primary: true,
        showToUnlogged: false,
        showToLogged: true,
      },
    ],
    [userSheet]
  );
}
